// @flow
import { fetchPatientData } from './patientActions';
import { SERVER_ADDRESS, fetchPost } from '../util/actionsUtil';

export const DELETE_PROBLEM_LOADING = 'DELETE_PROBLEM_LOADING';
export const DELETE_PROBLEM_SUCCESS = 'DELETE_PROBLEM_SUCCESS';
export const DELETE_PROBLEM_ERROR = 'DELETE_PROBLEM_ERROR';

function deleteProblem(patientId: string, problemId: string, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/problem/delete${type}Problem`,
      {
        problemId,
        patientId,
      },
      (data) => {
        dispatch({
          type: DELETE_PROBLEM_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: DELETE_PROBLEM_ERROR,
          error: error.toString(),
        });
      },
    );
    dispatch({
      type: DELETE_PROBLEM_LOADING,
    });
  });
}

export function deleteAcuteProblem(patientId: string, problemId: string) {
  return deleteProblem(patientId, problemId, 'Acute');
}
export function deleteChronicProblem(patientId: string, problemId: string) {
  return deleteProblem(patientId, problemId, 'Chronic');
}

export const ADD_PROBLEM_OLD_LOADING = 'ADD_PROBLEM_OLD_LOADING';
export const ADD_PROBLEM_OLD_SUCCESS = 'ADD_PROBLEM_OLD_SUCCESS';
export const ADD_PROBLEM_OLD_ERROR = 'ADD_PROBLEM_OLD_ERROR';

function addProblemOld(patientId: string, problem: Object, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/problem/add${type}ProblemOld`,
      {
        ...problem,
        patientId,
      },
      (data) => {
        dispatch({
          type: ADD_PROBLEM_OLD_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: ADD_PROBLEM_OLD_ERROR,
          error: error.toString(),
        });
      },
    );
    dispatch({
      type: ADD_PROBLEM_OLD_LOADING,
    });
  });
}

export function addAcuteProblem(patientId: string, problem: Object) {
  return addProblemOld(patientId, problem, 'Acute');
}
export function addChronicProblem(patientId: string, problem: Object) {
  return addProblemOld(patientId, problem, 'Chronic');
}

export const UPDATE_PROBLEM_LOADING = 'UPDATE_PROBLEM_LOADING';
export const UPDATE_PROBLEM_SUCCESS = 'UPDATE_PROBLEM_SUCCESS';
export const UPDATE_PROBLEM_ERROR = 'UPDATE_PROBLEM_ERROR';

function updateProblem(patientId: string, problem: Object, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/problem/update${type}Problem`,
      {
        ...problem,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_PROBLEM_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_PROBLEM_ERROR,
          error: error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_PROBLEM_LOADING,
    });
  });
}

export function updateAcuteProblem(patientId: string, problem: Object) {
  return updateProblem(patientId, problem, 'Acute');
}
export function updateChronicProblem(patientId: string, problem: Object) {
  return updateProblem(patientId, problem, 'Chronic');
}

export const ADD_PROBLEM_LOADING = 'ADD_PROBLEM_LOADING';
export const ADD_PROBLEM_SUCCESS = 'ADD_PROBLEM_SUCCESS';
export const ADD_PROBLEM_ERROR = 'ADD_PROBLEM_ERROR';

export function addProblem(patientId: string, values: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/problem/addProblem`,
      {
        ...values,
        patientId,
      },
      (data) => {
        dispatch({
          type: ADD_PROBLEM_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: ADD_PROBLEM_ERROR,
          error: error.toString(),
        });
      },
    );
    dispatch({
      type: ADD_PROBLEM_LOADING,
    });
  });
}



// WEBPACK FOOTER //
// ./client/src/actions/problemActions.js